import React from 'react'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { Icon, IconChoices } from '../../../common/Icon'
import { cn } from '../../../../helpers/utils'

interface MessageBarUploadProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  imageUploadDisabled: boolean
  onUploadImage: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const MessageBarUpload = <T extends FieldValues>({
  control,
  name,
  imageUploadDisabled,
  onUploadImage,
}: MessageBarUploadProps<T>): JSX.Element => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    onUploadImage(e)
  }

  return (
    <Controller
      control={control}
      name={name}
      render={() => (
        <label
          htmlFor="chat-image-input"
          className={cn(
            imageUploadDisabled
              ? 'pointer-events-none cursor-not-allowed opacity-50'
              : 'hover:bg-gray-light',
            'flex p-2 max-h-[44px] self-end'
          )}
        >
          <Icon icon={IconChoices.IMAGE} size={26} />

          <input
            id="chat-image-input"
            type="file"
            accept="image/png, image/jpg, image/jpeg"
            className="w-0 max-w-0 opacity-0"
            tabIndex={0}
            multiple
            disabled={imageUploadDisabled}
            onChange={onChange}
          />
        </label>
      )}
    />
  )
}
